import React from "react";
import { Card, ProgressBar } from "react-bootstrap";
import { FaSpinner, FaHourglassHalf } from "react-icons/fa";

const UploadLoader = ({ fileName, progress = 70, isDark }) => {
  const textColor = isDark ? "#f1f1f1" : "#000";
  const bgColor = isDark ? "#2b2b2b" : "#f8f9fa";

  return (
    <Card
      className="border-0 shadow-sm mt-4 mx-auto text-center"
      style={{
        backgroundColor: bgColor,
        color: textColor,
        borderRadius: "12px",
        padding: "20px",
        maxWidth: "420px",
      }}
    >
      <div className="d-flex justify-content-center align-items-center mb-3 gap-2">
        <FaSpinner
          className="spin"
          style={{ fontSize: "1.25rem" }}
        />
        <div style={{ fontWeight: 500, fontSize: "1rem" }}>
          Uploading <span style={{ opacity: 0.8 }}>{fileName || "file..."}</span>
        </div>
      </div>

      <ProgressBar
        now={progress}
        animated
        striped
        variant={isDark ? "light" : "primary"}
        style={{ height: "8px", borderRadius: "8px" }}
      />

      <small className="d-block mt-2 d-flex align-items-center justify-content-center gap-1" style={{ opacity: 0.8 }}>
        <FaHourglassHalf /> Please wait while your file is being securely uploaded
      </small>

      {/* Add simple CSS animation for spinner */}
      <style>
        {`
          .spin {
            animation: spin 1s linear infinite;
          }
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
    </Card>
  );
};

export default UploadLoader;
